// src/services/myAccountService.ts — the signed-in operator's OWN account reads
// for /console/account: GET /api/v2/user/me (identity + twoFactorAuth status —
// the same TOTP the admin step-up ceremony demands on money actions) and
// GET /api/v2/login-history (this user's recorded sign-ins: device, browser, IP).
// Both are personal-scope endpoints — they only ever return the caller's data.
import { useApiQuery } from "../hooks/useApiRequest";

export interface MyTwoFactorStatus {
  enabled: boolean;
  /** server-side actions that demand a TOTP code while enabled */
  requiredForActions: string[];
}

/** Subset of the /user/me payload the account page renders. */
export interface MyProfile {
  _id?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  createdAt?: string;
  twoFactorAuth?: MyTwoFactorStatus;
}

export interface SignInEntry {
  _id?: string;
  ipAddress?: string;
  device?: string;
  browser?: string;
  createdAt?: string;
}

export interface SignInsPage {
  results?: SignInEntry[];
  entries?: SignInEntry[];
  totalItems?: number;
  total?: number;
}

export const MY_ACCOUNT_KEY = "my-account";

export const useMyProfile = () =>
  useApiQuery<MyProfile>({
    key: [MY_ACCOUNT_KEY, "profile"],
    endPoint: "/api/v2/user/me",
  });

export const useMySignIns = (limit = 8) =>
  useApiQuery<SignInsPage>({
    key: [MY_ACCOUNT_KEY, "sign-ins", limit],
    endPoint: `/api/v2/login-history?page=1&limit=${limit}`,
  });
